type EventName =
  | 'sw:add-to-cart'
  | 'sw:remove-from-cart'
  | 'sw:login'
  | 'sw:signup'
  | 'sw:logout'
  | 'sw:checkout-start'
  | 'sw:checkout-click'
  | 'sw:checkout-auth-redirect'
  | 'sw:checkout-validation-error'
  | 'sw:checkout-submit'
  | 'sw:checkout-attempt'
  | 'sw:checkout-payment-open'
  | 'sw:search-results'
  | 'sw:search-result-click'
  | 'sw:order-placed'
  | 'sw:view-change';

export function emit(name: EventName, detail?: Record<string, unknown>) {
  if (typeof window === 'undefined') return;
  if (window.location.pathname.includes('/preview-proxy')) return;
  window.dispatchEvent(new CustomEvent(name, { detail: detail ?? {} }));

  // GTM dataLayer push
  const w = window as any;
  if (Array.isArray(w.dataLayer)) {
    w.dataLayer.push({ event: name, ...detail });
  }
}
